import React from 'react';
import { Spinner } from 'react-bootstrap';

/* ── ícone reutilizável ── */
const Icon = ({ d, size = 16, color = 'currentColor', stroke = 2 }) => (
  <svg width={size} height={size} fill="none" stroke={color} viewBox="0 0 24 24" style={{ flexShrink: 0 }}>
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={stroke} d={d} />
  </svg>
);

const ICONS = {
  calendar: 'M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z',
  generate: 'M9 17v-2m3 2v-4m3 4v-6m2 10H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z',
  detail:   'M15 12a3 3 0 11-6 0 3 3 0 016 0zM2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z',
  process:  'M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z',
  export:   'M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4',
  info:     'M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z',
  warn:     'M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z',
  money:    'M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z',
};

const formatCurrency = (value) => {
  const n = parseFloat(value);
  if (isNaN(n)) return 'R$ 0,00';
  return n.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
};

/* ── tooltip simples ── */
const Tip = ({ text, children }) => {
  const [show, setShow] = React.useState(false);
  if (!text) return children;
  return (
    <span
      style={{ position: 'relative', display: 'inline-flex', alignItems: 'center' }}
      onMouseEnter={() => setShow(true)}
      onMouseLeave={() => setShow(false)}
    >
      {children}
      {show && (
        <span style={{
          position: 'absolute', bottom: '130%', left: '50%',
          transform: 'translateX(-50%)',
          backgroundColor: '#1e293b', color: '#fff', fontSize: `calc(11px * var(--font-scale))`,
          padding: '6px 10px', borderRadius: '6px', zIndex: 999,
          boxShadow: '0 4px 12px rgba(0,0,0,0.2)', pointerEvents: 'none',
          maxWidth: '220px', whiteSpace: 'normal',
          textAlign: 'center', lineHeight: '1.4',
        }}>
          {text}
          <span style={{
            position: 'absolute', top: '100%', left: '50%',
            transform: 'translateX(-50%)',
            borderWidth: '5px', borderStyle: 'solid',
            borderColor: '#1e293b transparent transparent transparent',
          }} />
        </span>
      )}
    </span>
  );
};

/* ── badge de status ── */
const StatusBadge = ({ status }) => {
  const cfg = {
    'Paga':                    { bg: '#f0fdf4', color: '#16a34a', border: '#bbf7d0' },
    'Processada':              { bg: '#fffbeb', color: '#d97706', border: '#fde68a' },
    'Liberado para Pagamento': { bg: '#fffbeb', color: '#d97706', border: '#fde68a' },
  };
  const s = cfg[status] || { bg: '#f8fafc', color: '#64748b', border: '#e2e8f0' };
  return (
    <span style={{
      fontSize: `calc(11px * var(--font-scale))`, fontWeight: '700', padding: '2px 8px',
      borderRadius: '999px', backgroundColor: s.bg,
      color: s.color, border: `1px solid ${s.border}`,
    }}>
      {status || 'Pendente'}
    </span>
  );
};

/* ════════════════════════════════════════════════════════ */

const FolhaPagamentoTab = ({
  mesFolha, setMesFolha, anoFolha, setAnoFolha,
  dadosFolhaPagamento, isLoadingFolha, resumoFolha,
  isProcessingFolhaFinal,
  handleGerarOuVisualizarFolha, handleProcessarFolhaFinal,
  handleOpenDetalhesHoleriteModal,
}) => {
  const hoje              = new Date();
  const mesAtual          = hoje.getMonth() + 1;
  const anoAtual          = hoje.getFullYear();
  const isPeriodoInvalido = anoFolha > anoAtual || (anoFolha === anoAtual && mesFolha >= mesAtual);
  const periodoLabel      = `${String(mesFolha).padStart(2, '0')}/${anoFolha}`;

  const inputStyle = {
    padding: '8px 12px', borderRadius: '8px', border: '1px solid #e5e7eb',
    fontSize: `calc(13px * var(--font-scale))`, color: '#374151',
    fontFamily: "'Inter','Segoe UI',sans-serif",
    outline: 'none', backgroundColor: '#fff',
    transition: 'border-color 0.15s, box-shadow 0.15s',
  };
  const focusHandlers = {
    onFocus: e => { e.target.style.borderColor = '#2563eb'; e.target.style.boxShadow = '0 0 0 3px rgba(37,99,235,0.1)'; },
    onBlur:  e => { e.target.style.borderColor = '#e5e7eb'; e.target.style.boxShadow = 'none'; },
  };

  /* ── helpers de cor para botões ── */
  const gerarDisabled = isLoadingFolha || resumoFolha?.statusFolha === 'Paga' || isPeriodoInvalido;
  const processarDisabled = isLoadingFolha || isProcessingFolhaFinal || resumoFolha?.statusFolha !== 'Processada';

  return (
    <div style={{ fontFamily: "'Inter','Segoe UI',sans-serif" }}>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap');
        .folha-table { width: 100%; border-collapse: collapse; }
        .folha-table th {
          padding: 10px 14px; font-size: 11px; font-weight: 700;
          color: #64748b; text-transform: uppercase; letter-spacing: 0.5px;
          border-bottom: 2px solid #e2e8f0;
          background: linear-gradient(135deg,#f8fafc,#f1f5f9);
          text-align: right; white-space: nowrap;
        }
        .folha-table th:first-child,
        .folha-table th:nth-child(2),
        .folha-table th:last-child,
        .folha-table th:nth-last-child(2) { text-align: left; }
        .folha-table td {
          padding: 11px 14px; font-size: calc(13px * var(--font-scale)) color: #374151;
          border-bottom: 1px solid #f1f5f9;
          vertical-align: middle; text-align: right;
        }
        .folha-table td:first-child,
        .folha-table td:nth-child(2) { text-align: left; }
        .folha-table tbody tr:hover { background: #fafbff; }
        @media (max-width: 991px) { .hide-lg { display: none !important; } }
        @media (max-width: 767px) { .hide-md { display: none !important; } }
      `}</style>

      {/* ── FILTRO DE PERÍODO ── */}
      <div style={{
        backgroundColor: '#fff', borderRadius: '12px',
        border: '1px solid #e5e7eb', padding: '20px 24px', marginBottom: '20px',
      }}>
        <p style={{
          fontSize: `calc(10px * var(--font-scale))`, fontWeight: '700', color: '#9ca3af',
          textTransform: 'uppercase', letterSpacing: '0.8px', marginBottom: '14px',
        }}>
          Período da Folha
        </p>

        <div style={{ display: 'flex', gap: '12px', alignItems: 'flex-end', flexWrap: 'wrap' }}>

          {/* Mês */}
          <div>
            <label style={{
              fontSize: `calc(11px * var(--font-scale))`, fontWeight: '700', color: '#6b7280',
              textTransform: 'uppercase', letterSpacing: '0.5px',
              display: 'block', marginBottom: '5px',
            }}>Mês</label>
            <select
              style={{ ...inputStyle, minWidth: '80px', appearance: 'auto' }}
              value={mesFolha}
              onChange={e => setMesFolha(parseInt(e.target.value, 10))}
              {...focusHandlers}
            >
              {Array.from({ length: 12 }, (_, i) => i + 1).map(m => (
                <option key={m} value={m}>{String(m).padStart(2, '0')}</option>
              ))}
            </select>
          </div>

          {/* Ano */}
          <div>
            <label style={{
              fontSize: `calc(11px * var(--font-scale))`, fontWeight: '700', color: '#6b7280',
              textTransform: 'uppercase', letterSpacing: '0.5px',
              display: 'block', marginBottom: '5px',
            }}>Ano</label>
            <input
              type="number"
              style={{ ...inputStyle, width: '90px' }}
              value={anoFolha}
              onChange={e => setAnoFolha(parseInt(e.target.value, 10))}
              min="2025" max={anoAtual + 1}
              {...focusHandlers}
            />
          </div>

          {/* Botão gerar */}
          <Tip text={isPeriodoInvalido ? 'A folha só pode ser gerada para meses anteriores ao atual.' : ''}>
            <button
              onClick={handleGerarOuVisualizarFolha}
              disabled={gerarDisabled}
              style={{
                display: 'flex', alignItems: 'center', gap: '7px',
                padding: '9px 18px', borderRadius: '8px', border: 'none',
                background: gerarDisabled
                  ? '#e5e7eb'
                  : 'linear-gradient(135deg, #1e3a5f, #2563eb)',
                color:  gerarDisabled ? '#9ca3af' : '#fff',
                cursor: gerarDisabled ? 'not-allowed' : 'pointer',
                fontSize: `calc(13px * var(--font-scale))`, fontWeight: '600', fontFamily: 'inherit',
                boxShadow: gerarDisabled ? 'none' : '0 2px 8px rgba(37,99,235,0.25)',
                transition: 'all 0.15s',
              }}
            >
              {isLoadingFolha
                ? <Spinner as="span" animation="border" size="sm" style={{ width: '14px', height: '14px', borderWidth: '2px' }} />
                : <Icon d={ICONS.generate} size={14} color="currentColor" />
              }
              {isLoadingFolha
                ? 'Carregando...'
                : (resumoFolha?.statusFolha === 'Processada' || resumoFolha?.statusFolha === 'Paga')
                  ? 'Visualizar Folha'
                  : 'Gerar Folha'
              }
            </button>
          </Tip>

          {/* Badge de status */}
          {resumoFolha?.statusFolha && (
            <div style={{ paddingBottom: '2px' }}>
              <StatusBadge status={resumoFolha.statusFolha} />
            </div>
          )}
        </div>

        {/* Aviso período inválido */}
        {isPeriodoInvalido && (
          <div style={{ display: 'flex', alignItems: 'center', gap: '6px', marginTop: '10px' }}>
            <Icon d={ICONS.warn} size={13} color="#d97706" />
            <span style={{ fontSize: `calc(12px * var(--font-scale))`, color: '#d97706' }}>
              Selecione um mês anterior ao atual para gerar a folha.
            </span>
          </div>
        )}
      </div>

      {/* ── CONTEÚDO ── */}
      {isLoadingFolha ? (

        <div style={{
          backgroundColor: '#fff', borderRadius: '12px',
          border: '1px solid #e5e7eb', padding: '60px',
          display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '12px',
        }}>
          <Spinner animation="border" variant="primary" style={{ width: '32px', height: '32px' }} />
          <p style={{ margin: 0, fontSize: `calc(13px * var(--font-scale))`, color: '#6b7280' }}>Gerando folha de pagamento...</p>
        </div>

      ) : dadosFolhaPagamento.length > 0 ? (
        <>
          {/* ── TABELA ── */}
          <div style={{
            backgroundColor: '#fff', borderRadius: '12px',
            border: '1px solid #e5e7eb', overflow: 'hidden', marginBottom: '20px',
          }}>
            {/* cabeçalho */}
            <div style={{
              display: 'flex', alignItems: 'center', justifyContent: 'space-between',
              padding: '14px 20px', borderBottom: '1px solid #e5e7eb',
              background: 'linear-gradient(135deg, #f8fafc, #f1f5f9)',
            }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                <Icon d={ICONS.generate} size={15} color="#2563eb" />
                <span style={{ fontSize: `calc(13px * var(--font-scale))`, fontWeight: '700', color: '#374151' }}>
                  Folha de Pagamento — {periodoLabel}
                </span>
              </div>
              <span style={{
                fontSize: `calc(11px * var(--font-scale))`, fontWeight: '700', color: '#2563eb',
                backgroundColor: '#eff6ff', padding: '3px 10px',
                borderRadius: '999px', border: '1px solid #bfdbfe',
              }}>
                {dadosFolhaPagamento.length} colaborador{dadosFolhaPagamento.length !== 1 ? 'es' : ''}
              </span>
            </div>

            <div style={{ overflowX: 'auto' }}>
              <table className="folha-table">
                <thead>
                  <tr>
                    <th style={{ textAlign: 'left' }}>Colaborador</th>
                    <th style={{ textAlign: 'left' }} className="hide-md">Cargo</th>
                    <th>
                      <Tip text="Resgatado do perfil do funcionário em Pessoal › Colaboradores.">
                        <span style={{ display: 'inline-flex', alignItems: 'center', gap: '4px', cursor: 'default' }}>
                          Salário Base
                          <Icon d={ICONS.info} size={11} color="#94a3b8" />
                        </span>
                      </Tip>
                    </th>
                    <th className="hide-lg">
                      <Tip text="Registrado em Pessoal › Colaboradores › Lançamentos.">
                        <span style={{ display: 'inline-flex', alignItems: 'center', gap: '4px', cursor: 'default' }}>
                          H. Extras
                          <Icon d={ICONS.info} size={11} color="#94a3b8" />
                        </span>
                      </Tip>
                    </th>
                    <th className="hide-lg">
                      <Tip text="Registrado em Pessoal › Colaboradores › Lançamentos.">
                        <span style={{ display: 'inline-flex', alignItems: 'center', gap: '4px', cursor: 'default' }}>
                          Adicionais
                          <Icon d={ICONS.info} size={11} color="#94a3b8" />
                        </span>
                      </Tip>
                    </th>
                    <th className="hide-md">INSS</th>
                    <th className="hide-md">IRRF</th>
                    <th className="hide-md">
                      <Tip text="Registrado em Pessoal › Colaboradores › Lançamentos.">
                        <span style={{ display: 'inline-flex', alignItems: 'center', gap: '4px', cursor: 'default' }}>
                          Outros Desc.
                          <Icon d={ICONS.info} size={11} color="#94a3b8" />
                        </span>
                      </Tip>
                    </th>
                    <th style={{ color: '#111827' }}>Líquido</th>
                    <th style={{ textAlign: 'left' }} className="hide-md">Status</th>
                    <th style={{ textAlign: 'left' }} className="hide-md">Ações</th>
                  </tr>
                </thead>
                <tbody>
                  {dadosFolhaPagamento.map((item, index) => {
                    const proventos = item.lancamentos?.filter(l => l.tipo_evento_historico === 'provento') || [];
                    const descontos = item.lancamentos?.filter(l => l.tipo_evento_historico === 'desconto') || [];

                    const horasExtras = proventos
                      .find(p => p.descricao_evento_historico.includes('Horas Extras'))
                      ?.valor_calculado || 0;

                    const adicionais = proventos
                      .filter(p =>
                        !p.descricao_evento_historico.includes('Salário Base') &&
                        !p.descricao_evento_historico.includes('Horas Extras') &&
                        !p.descricao_evento_historico.includes('Pagamento de Serviços (PJ)')
                      )
                      .reduce((s, p) => s + p.valor_calculado, 0);

                    const descontoINSS = descontos
                      .find(d => d.descricao_evento_historico.includes('INSS'))
                      ?.valor_calculado || 0;

                    const descontoIRRF = descontos
                      .find(d => d.descricao_evento_historico.includes('IRRF'))
                      ?.valor_calculado || 0;

                    const outrosDescontos = descontos
                      .filter(d =>
                        !d.descricao_evento_historico.includes('INSS') &&
                        !d.descricao_evento_historico.includes('IRRF')
                      )
                      .reduce((s, d) => s + d.valor_calculado, 0);

                    return (
                      <tr key={item.id_funcionario || `item-${index}`}>

                        {/* ── Colaborador (avatar + nome) ── */}
                        <td style={{ textAlign: 'left' }}>
                          <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                            <div style={{
                              width: '30px', height: '30px', borderRadius: '50%', flexShrink: 0,
                              background: 'linear-gradient(135deg, #eff6ff, #dbeafe)',
                              display: 'flex', alignItems: 'center', justifyContent: 'center',
                            }}>
                              <span style={{ fontSize: `calc(11px * var(--font-scale))`, fontWeight: '700', color: '#2563eb' }}>
                                {(item.nome || '?')[0].toUpperCase()}
                              </span>
                            </div>
                            <span style={{ fontWeight: '600', color: '#111827' }}>{item.nome}</span>
                          </div>
                        </td>

                        {/* ── Cargo ── */}
                        <td style={{ textAlign: 'left' }} className="hide-md">{item.cargo}</td>

                        {/* ── Salário base ── */}
                        <td>{formatCurrency(item.salarioBase)}</td>

                        {/* ── Horas extras ── */}
                        <td className="hide-lg">{formatCurrency(horasExtras)}</td>

                        {/* ── Adicionais ── */}
                        <td className="hide-lg">{formatCurrency(adicionais)}</td>

                        {/* ── Descontos (vermelho) ── */}
                        <td className="hide-md" style={{ color: '#dc2626' }}>
                          {descontoINSS > 0 ? `(${formatCurrency(descontoINSS)})` : '—'}
                        </td>
                        <td className="hide-md" style={{ color: '#dc2626' }}>
                          {descontoIRRF > 0 ? `(${formatCurrency(descontoIRRF)})` : '—'}
                        </td>
                        <td className="hide-md" style={{ color: '#dc2626' }}>
                          {outrosDescontos > 0 ? `(${formatCurrency(outrosDescontos)})` : '—'}
                        </td>

                        {/* ── Líquido ── */}
                        <td>
                          <span style={{ fontWeight: '700', color: '#111827', fontSize: `calc(13px * var(--font-scale))` }}>
                            {formatCurrency(item.valorLiquido)}
                          </span>
                        </td>

                        {/* ── Status ── */}
                        <td style={{ textAlign: 'left' }} className="hide-md">
                          <StatusBadge status={item.status} />
                        </td>

                        {/* ── Ações ── */}
                        <td style={{ textAlign: 'left' }} className="hide-md">
                          <button
                            onClick={() => handleOpenDetalhesHoleriteModal(item)}
                            style={{
                              display: 'inline-flex', alignItems: 'center', gap: '5px',
                              padding: '5px 10px', borderRadius: '6px',
                              border: '1px solid #bfdbfe',
                              backgroundColor: '#eff6ff', color: '#2563eb',
                              fontSize: `calc(12px * var(--font-scale))`, fontWeight: '600',
                              cursor: 'pointer', fontFamily: 'inherit',
                            }}
                            onMouseEnter={e => e.currentTarget.style.backgroundColor = '#dbeafe'}
                            onMouseLeave={e => e.currentTarget.style.backgroundColor = '#eff6ff'}
                          >
                            <Icon d={ICONS.detail} size={12} color="#2563eb" />
                            Detalhes
                          </button>
                        </td>

                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </div>

          {/* ── RESUMO DA FOLHA ── */}
          <div style={{
            backgroundColor: '#fff', borderRadius: '12px',
            border: '1px solid #e5e7eb', overflow: 'hidden',
          }}>
            <div style={{
              padding: '14px 20px', borderBottom: '1px solid #e5e7eb',
              background: 'linear-gradient(135deg, #f8fafc, #f1f5f9)',
              display: 'flex', alignItems: 'center', gap: '8px',
            }}>
              <Icon d={ICONS.money} size={15} color="#2563eb" />
              <span style={{ fontSize: `calc(13px * var(--font-scale))`, fontWeight: '700', color: '#374151' }}>
                Resumo — {periodoLabel}
              </span>
            </div>

            <div style={{ padding: '20px 24px' }}>
              {/* Cards de totais */}
              <div style={{ display: 'flex', gap: '14px', flexWrap: 'wrap', marginBottom: '20px' }}>
                {[
                  { label: 'Total Bruto',          value: resumoFolha.totalBruto,     bg: '#f0fdf4', color: '#16a34a', border: '#bbf7d0' },
                  { label: 'Total Descontos',       value: resumoFolha.totalDescontos, bg: '#fef2f2', color: '#dc2626', border: '#fecaca' },
                  { label: 'Total Líquido a Pagar', value: resumoFolha.totalLiquido,   bg: '#eff6ff', color: '#2563eb', border: '#bfdbfe' },
                ].map(card => (
                  <div key={card.label} style={{
                    flex: '1 1 160px', padding: '14px 18px', borderRadius: '10px',
                    backgroundColor: card.bg, border: `1px solid ${card.border}`,
                  }}>
                    <p style={{
                      margin: '0 0 4px', fontSize: `calc(11px * var(--font-scale))`, fontWeight: '700',
                      color: '#6b7280', textTransform: 'uppercase', letterSpacing: '0.5px',
                    }}>
                      {card.label}
                    </p>
                    <p style={{ margin: 0, fontSize: '18px', fontWeight: '700', color: card.color }}>
                      {formatCurrency(card.value)}
                    </p>
                  </div>
                ))}
              </div>

              {/* Botões */}
              <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap' }}>

                <button
                  onClick={handleProcessarFolhaFinal}
                  disabled={processarDisabled}
                  style={{
                    display: 'flex', alignItems: 'center', gap: '7px',
                    padding: '9px 20px', borderRadius: '8px', border: 'none',
                    background: processarDisabled
                      ? '#e5e7eb'
                      : 'linear-gradient(135deg, #065f46, #059669)',
                    color:  processarDisabled ? '#9ca3af' : '#fff',
                    cursor: processarDisabled ? 'not-allowed' : 'pointer',
                    fontSize: `calc(13px * var(--font-scale))`, fontWeight: '600', fontFamily: 'inherit',
                    boxShadow: processarDisabled ? 'none' : '0 2px 8px rgba(5,150,105,0.3)',
                    transition: 'all 0.15s',
                  }}
                >
                  {isProcessingFolhaFinal
                    ? <Spinner as="span" animation="border" size="sm" style={{ width: '14px', height: '14px', borderWidth: '2px' }} />
                    : <Icon d={ICONS.process} size={14} color="currentColor" />
                  }
                  {isProcessingFolhaFinal
                    ? 'Processando...'
                    : resumoFolha?.statusFolha === 'Paga'
                      ? 'Folha Paga'
                      : 'Processar Folha'
                  }
                </button>

                <button
                  disabled
                  style={{
                    display: 'flex', alignItems: 'center', gap: '7px',
                    padding: '9px 20px', borderRadius: '8px',
                    border: '1px solid #e5e7eb', backgroundColor: '#f9fafb',
                    color: '#9ca3af', cursor: 'not-allowed',
                    fontSize: `calc(13px * var(--font-scale))`, fontWeight: '600', fontFamily: 'inherit',
                  }}
                >
                  <Icon d={ICONS.export} size={14} color="#9ca3af" />
                  Exportar p/ Contabilidade
                </button>

              </div>
            </div>
          </div>
        </>

      ) : (
        /* ── ESTADO VAZIO ── */
        <div style={{
          backgroundColor: '#fff', borderRadius: '12px',
          border: '1px dashed #e5e7eb', padding: '60px 24px',
          textAlign: 'center',
        }}>
          <div style={{
            width: '56px', height: '56px', borderRadius: '14px',
            background: 'linear-gradient(135deg, #f1f5f9, #e2e8f0)',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            margin: '0 auto 14px',
          }}>
            <Icon d={ICONS.generate} size={24} color="#94a3b8" />
          </div>
          <p style={{ margin: '0 0 4px', fontSize: `calc(14px * var(--font-scale))`, fontWeight: '600', color: '#374151' }}>
            Nenhuma folha gerada
          </p>
          <p style={{ margin: 0, fontSize: `calc(12px * var(--font-scale))`, color: '#9ca3af' }}>
            Selecione o período e clique em <strong>"Gerar Folha"</strong> para visualizar os dados.
          </p>
        </div>
      )}
    </div>
  );
};

export default FolhaPagamentoTab;
